import { SlicePipe } from "@angular/common";
import { Component, computed, input, ChangeDetectionStrategy } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { S25ItemModule } from "../../modules/s25-item/s25.item.module";
import { S25RouterLinkDirective } from "../../modules/s25-nav-bar/s25.router.link.directive";
import { EventSummary } from "../../modules/s25-swarm-schedule/s25.event.summary.service";
import { Item } from "../../pojo/Item";
import { StateService } from "../../services/state.service";
import { S25Const } from "../../util/s25-const";

@TypeManagerDecorator("s25-ng-item-more")
@Component({
    selector: "s25-ng-item-more",
    standalone: true,
    template: `
        @for (item of items() | slice: 0 : 3; track item.itemId) {
            @let isPrivate = item.itemName === S25Const.private;
            @if (item.is_hidden == 1) {
                <a class="s25-item s25-item-body angular summary s25-object" href="javascript:void(0)">
                    <div class="transcluded-content">
                        {{ item.itemName }}
                    </div>
                </a>
            } @else {
                <s25-item
                    [itemId]="item.itemId"
                    [itemName]="item.itemName"
                    [itemTypeId]="item.itemTypeId"
                    [placement]="'bottom-left'"
                    [includeTypeIcon]="true"
                    [hideLabel]="true"
                >
                    <span class="s25-item-name" [class.s25-item-link]="!isPrivate">
                        {{ item.itemName }}
                        @if (item.itemTypeId === Item.Ids.Resource && !isPrivate) {
                            <span>[{{ getDisplayQuantity(item) }}]</span>
                        }
                    </span>
                </s25-item>
            }
        }
        @if (totalCount() > items().length) {
            <!-- this could be a relative link when we're using angular routing -->
            <a class="view-all-link" s25-ng-router-link [stateName]="'eventOccurrences'" [stateParams]="moreParams()">
                View All
            </a>
        }
    `,
    styles: `
        .view-all-link {
            width: fit-content;
        }
        .view-all-link,
        .s25-item-link {
            color: var(--color--link-text);
        }
        s25-item:hover .s25-item-link,
        .view-all-link:hover {
            text-decoration: underline;
        }
        s25-item:hover .s25-item-link,
        s25-item:focus-within .s25-item-link,
        .view-all-link:hover,
        .view-all-link:focus {
            color: var(--color--link-text-hover);
        }
        s25-item:focus-within ::ng-deep div[tabindex],
        .view-all-link:focus {
            outline-color: var(--color--link-text-hover);
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SlicePipe, S25RouterLinkDirective, S25ItemModule],
})
export class S25ItemMoreComponent {
    public readonly items = input.required<Array<EventSummary.Location | EventSummary.Resource>>();

    /**
     * items may be an array up to length 3, but the individual items contain the total count
     */
    public readonly totalCount = computed<number>(() => (this.items()?.length ? this.items()[0].count : 0));
    public readonly moreParams = computed(() => ({
        itemId: StateService.getState().params.itemId,
    }));

    protected readonly Item = Item;
    protected readonly S25Const = S25Const;

    getDisplayQuantity(resource: EventSummary.Resource) {
        return resource.maxQuantity === resource.minQuantity
            ? resource.maxQuantity
            : resource.minQuantity + " - " + resource.maxQuantity;
    }
}
